<div class="error-page">
  <header class="header d-flex justify-content-between">
    <plys-shop-logo></plys-shop-logo>
  </header>

  <main class="main">
    @if (data$ | async; as data) {
      <div class="row">
        <div class="col-12">
          <div class="card d-flex flex-column justify-content-center">
            <h2 class="text-xxl text-center mb-5">{{ data.titleKey | transloco }}</h2>
            <p class="text-md text-center mb-4">
              {{ data.messageKey | transloco }}
            </p>
          </div>
        </div>
      </div>
    }
  </main>
</div>
